interface SvgChevronRightProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgChevronRight(props: SvgChevronRightProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M16.5001 12L9.00007 19.5L7.95007 18.45L14.4001 12L7.95007 5.55L9.00007 4.5L16.5001 12Z" fill="currentColor" /></svg>;
}